import { useCallback, useState } from 'react';

const STORAGE_KEY = 'arcade-theme';

export const applyStoredTheme = () => {
  const stored = localStorage.getItem(STORAGE_KEY);
  document.documentElement.dataset.theme = stored === 'light' ? 'light' : 'dark';
};

export const useTheme = () => {
  const [theme, setTheme] = useState(
    () => document.documentElement.dataset.theme || 'dark'
  );

  const toggleTheme = useCallback(() => {
    setTheme(prev => {
      const next = prev === 'dark' ? 'light' : 'dark';
      document.documentElement.dataset.theme = next;
      localStorage.setItem(STORAGE_KEY, next);
      return next;
    });
  }, []);

  return { theme, toggleTheme };
};
